import React,{ useState } from 'react'
import { useEffect } from 'react'
import { AddCourseApi, getCourseListAPI, UpdateCourseAPI } from '../../API/AdminServices'
import Button from '../../Components/Button/Button'
import Divider from '../../Components/Divider/Divider'
import { errorToast, succToast } from '../../Toast/Toast'
import Style from './AddCourse.module.css'
import ThreeHorseLoading from 'react-loadingg/lib/ThreeHorseLoading'
const AddCourse = () => {
    const[loading,setLoading]=useState(false)
    const[courseList,setCourseList]=useState()
    const[courseId,setCourseId]=useState('0')
    useEffect(()=>{
        getCourseList()
    },[])
    const AddCourseHandler=()=>{
        setLoading(true)
        AddCourseApi((succ)=>{
            if(succ.status===1){
                succToast(succ.message)
                setLoading(false)
            }
            else{
                errorToast(succ.message)
                setLoading(false)
            }
        })
    }
    const getCourseList=async()=>{
        const data=await getCourseListAPI()
        setCourseList(data.courses)
    }
    let loadingHandler=null
    if(courseList===undefined){
        loadingHandler=<div style={{margin:"1rem",height:'3rem',}}>
            <ThreeHorseLoading/>
        </div>
    }
    else{
        loadingHandler=<select className={Style.SelectCourse} onChange={e=>setCourseId(e.target.value)}>
            <option value={'0'}> یک دوره انتخاب کنید:</option>
            {                
            courseList.map(item=>{
                return(
                    <option key={item.id} value={item.id}>{item.name}</option>
                )
            })
            }
        </select>

    }
    const UpdateCourseHandler=()=>{
        if(courseId==='0'){
            errorToast('لطفا یک دوره را انتخاب کنید')
        }
        else{
            let info={
                id:courseId
            }
            UpdateCourseAPI(info,(succ)=>{
                if(succ.status===1){
                    succToast(succ.message)
                }
                else{
                    errorToast(succ.message)
                }
            })
        }
    }
    return (
        <div className={Style.PageHolder}>
            <section className={Style.AddCourseToSite}>
                <h3 ><sup>*</sup> چنانچه در اسپات پلیر دوره ای افزوده شد لطفا روی دکمه زیر کلیک کنید تا دوره در سایت هم قرار گیرد</h3>
                <Button Value={'ثبت'} ClassBtn={'confirmBtn'} clickhandler={AddCourseHandler}/>
            </section>
            <Divider/>
            <section className={Style.AddCourseToSite}>
                <h3 ><sup>*</sup> چنانچه در اسپات پلیر دوره ای بروزرسانی یا تغییر داده شد لطفا ابتدا دوره مورد نظر را انتخاب کرده سپس روی دکمه زیر کلیک کنید تا دوره در سایت هم بروزرسانی شود</h3>
                {
                        loadingHandler
                }

                <Button Value={'ثبت'} ClassBtn={'confirmBtn'} clickhandler={UpdateCourseHandler}/>
            </section>
        </div>
    )
}

export default AddCourse
